// import { toast } from "react-hot-toast";
// import { AnimatePresence, motion } from "framer-motion";
// import LoadingGrey from "@/assets/icons/LoadingGrey.svg";
// import Check from "@/assets/icons/Check.svg";
// import Exclamation from "@/assets/icons/Exclamation.svg";

// export const showCustomToast = (
//   content: string,
//   icon?: "check" | "exclamation" | "loading"
// ) => {
//   toast.dismiss();
//   toast.custom((t) => (
//     <AnimatePresence>
//       {t.visible && (
//         <motion.div
//           initial={{ y: -50, opacity: 0 }} // Slide up from below
//           animate={{ y: 0, opacity: 1 }} // Slide to normal position
//           exit={{ y: -50, opacity: 0 }} // Slide down
//           transition={{ type: "spring", stiffness: 100 }}
//           style={{
//             backgroundColor: "rgba(29, 29, 29, 0.8)",
//             backdropFilter: "blur(40px)",
//             padding: "1px",
//             borderRadius: "108px",
//             height: 45,
//             color: "#fff",
//             fontSize: 14,
//             fontFamily: "Onest",
//             fontWeight: 500,
//             width: "fit-content",
//             margin: "0 auto",
//             display: "flex",
//           }}
//         >
//           <div
//             style={{
//               border: "0.5px solid rgba(255, 255, 255, 0.35)",
//               borderRadius: "78px",
//               padding: icon ? "0 16px 0 8px" : "0 16px",
//               height: "100%",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             {icon && (
//               <img
//                 className={`mr-[4px] ${
//                   icon === "loading" ? "animate-spin" : ""
//                 }`}
//                 src={
//                   icon === "exclamation"
//                     ? Exclamation
//                     : icon === "check"
//                     ? Check
//                     : LoadingGrey
//                 }
//               />
//             )}
//             {content}
//           </div>
//         </motion.div>
//       )}
//     </AnimatePresence>
//   ));
// };

import { toast } from "react-hot-toast";
import { AnimatePresence, motion } from "framer-motion";
import LoadingGrey from "@/assets/icons/LoadingGrey.svg";
import Check from "@/assets/icons/Check.svg";
import Exclamation from "@/assets/icons/Exclamation.svg";

export const showCustomToast = (
  content: string,
  icon?: "check" | "exclamation" | "loading",
  persistent?: boolean
) => {
  // Dismiss all previous toasts
  toast.dismiss();

  const toastId = toast.custom(
    (t) => (
      <AnimatePresence>
        {t.visible && (
          <motion.div
            initial={{ y: -50, opacity: 0 }} // Slide up from below
            animate={{ y: 0, opacity: 1 }} // Slide to normal position
            exit={{ y: -50, opacity: 0 }} // Slide down
            transition={{ type: "spring", stiffness: 100 }}
            style={{
              backgroundColor: "rgba(29, 29, 29, 0.8)",
              backdropFilter: "blur(40px)",
              padding: "1px",
              borderRadius: "108px",
              height: 45,
              color: "#fff",
              fontSize: 14,
              fontFamily: "Onest",
              fontWeight: 500,
              width: "fit-content",
              margin: "0 auto",
              display: "flex",
            }}
          >
            <div
              style={{
                border: "0.5px solid rgba(255, 255, 255, 0.35)",
                borderRadius: "78px",
                padding: icon ? "0 16px 0 8px" : "0 16px",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {icon && (
                <img
                  className={`mr-[4px] ${
                    icon === "loading" ? "animate-spin" : ""
                  }`}
                  src={
                    icon === "exclamation"
                      ? Exclamation
                      : icon === "check"
                      ? Check
                      : LoadingGrey
                  }
                  alt={icon}
                />
              )}
              {content}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    ),
    {
      duration: persistent || icon === "loading" ? Infinity : 3000, // Persistent or loading toasts don't auto-dismiss
    }
  );

  return toastId;
};
